import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseError401Component } from './error-401.component';

const routes = [
    {
        path     : 'pages/errors/error-401',
        component: FuseError401Component
    }
];

@NgModule({
    declarations: [
        FuseError401Component
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class Error401Module
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/errors/401/error-401.module.ts